<template>
  <v-card style="height: 100%">
    <v-card-text class="pa-0 pb-4">
      <v-img
        :src="post.urlBase+'/'+post.urlPath"
        width="100%"
        height="150px"
        class="grey lighten-2"
      >
        <template #placeholder>
          <v-layout
            fill-height
            align-center
            justify-center
            ma-0
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            />
          </v-layout>
        </template>
      </v-img>

      <div
        class="text-center"
        style="margin-top: -30px"
      >
        <div style="">
          <v-avatar
            size="60"
            style="border: 3px solid #fff;"
          >
            <img
              loading="lazy"
              decoding="async"
              width="60"
              height="60"
              :src="post.urlBase+'/'+extras.fbAvatar"
              alt="John"
            >
          </v-avatar>
        </div>

        <div class="mt-1">
          {{ extras.fbNickname }}
        </div>
      </div>
      <div
        :title="post.content"
        class="text-center px-2 mt-2 line-clamp-2"
      >
        {{ post.content }}
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    post: Object,
    colWidth: Number,
  },
  computed: {
    extras () {
      if (typeof this.post.extras === 'object') { return this.post.extras }
      return JSON.parse(this.post.extras)
    },
    imgW () {
      // return window.innerWidth / 2 - 8 - 16
      return this.colWidth - 16
    },
    imgH () {
      return this.post.imageHeight / this.post.imageWidth * this.imgW
    }
  },
}
</script>
